<script lang="jsx">
import cartMixin from '@/plans/mx/shopping-cart';
import AltProratedPlanPrice from '@/views/config/shopping-cart/prorated/plan-price.vue';

export default {
  mixins: [cartMixin],
  name: 'ZoomPhoneAiConciergeCart',
  components: {
    AltProratedPlanPrice,
  },
  methods: {
    getTierLabel(plan) {
      if (plan?.is_payg) return this.$t('billing.pay_you_go');
      const mins = plan?.minutes;
      if (mins) {
        const minsText = new Intl.NumberFormat().format(mins);
        return `${this.$t('billing.prepaid')} ${minsText} ${this.$t('billing.pbx.zp_aic.mins_abbr')}`;
      }
      return '';
    },
    getUnitPriceText(plan) {
      return this.$money(plan?.totalAmount || 0);
    },
    $renderPrice() {
      if (!this.mx_plans.length) return;
      return (
        <div class="opc-cart-item">
          {this.mx_plans.map((plan) => {
            const isFreeTrial = !!plan?.isOnlineFreeTrial && !!plan?.trialDays;
            return (
              <div>
                {this.mx_title(
                  isFreeTrial ? this.$t('billing.planform.title.zoom_phone_ai_concierge_ft') : this.$t(plan.planNameKey),
                  <AltProratedPlanPrice type={plan.type}>
                    {isFreeTrial ? this.$money(0) : this.getUnitPriceText(plan)}
                  </AltProratedPlanPrice>,
                  plan?.plan_code,
                )}
                {isFreeTrial ? (
                  <>
                    <div class="opc-cart-item__text">{this.getTierLabel(plan)}</div>
                    <div class="opc-cart-item__text" style="color:#247F40;">
                      {this.$t('billing.pbx.free_trial.x_day_trial_desc', [plan.trialDays])}
                    </div>
                    {this.mx_freeTrialStartDate(this.mx_startDate)}
                  </>
                ) : (
                  <>
                    <div class="opc-cart-item__text">{this.getTierLabel(plan)}</div>
                    {this.mx_freeTrialStartDate(this.mx_startDate)}
                    {this.mx_cycle(plan.billing_cycle)}
                  </>
                )}
                {this.mx_edit(plan)}
                {this.mx_remove(plan)}
              </div>
            );
          })}
        </div>
      );
    },
  },
};
</script>

